import { render, staticRenderFns } from "./labelList.vue?vue&type=template&id=008918c6&scoped=true&"
import script from "./labelList.vue?vue&type=script&lang=ts&"
export * from "./labelList.vue?vue&type=script&lang=ts&"
import style0 from "./labelList.vue?vue&type=style&index=0&id=008918c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008918c6",
  null
  
)

export default component.exports